import * as type from '../types/library'

// \\ // \\ LIBRARY CONTENT // \\ // \\

export const retrieveLibraryFiles = payload => {
    return{
        type: type.REQUEST_LIBRARY_CONTENT,
        payload: payload
    }
}

export const resetLibraryFiles = () => {
    return{
        type: type.RESET_LIBRARY_CONTENT
    }
}

// \\ // \\ CHANGE MODAL DISPLAYS // \\ // \\
export const changeLibraryModal = payload => {
    return{
        type: type.CHANGE_LIBRARY_MODALS,
        modal: payload
    }
}

// \\ // \\ SET ACTIVE FILE // \\ // \\
export const setLibraryActiveFile = payload => {
    return{
        type: type.SET_LIBRARY_ACTIVE_FILE,
        fileId: payload
    }
}

// \\ // \\ CLEAR ACTIVE FILE // \\ // \\
export const clearLibraryActiveFile = () => {
    return{
        type: type.CLEAR_LIBRARY_ACTIVE_FILE,
        fileId: null
    }
}

// \\ // \\ UNLOCK FILE // \\ // \\
export const requestFileAccess = payload => {
    return{
        type: type.REQUEST_FILE_ACCESS,
        details: payload
    }
}

export const resetFileAccess = payload => {
    return{
        type: type.RESET_FILE_ACCESS,
        details: payload
    }
}

// \\ // \\ DELETE FILE // \\ // \\
export const requestFileDeletion = payload => {
    return{
        type: type.REQUEST_FILE_DELETION,
        details: payload
    }
}

export const resetFileDeletion = () => {
    return{
        type: type.RESET_FILE_DELETION
    }
}

// \\ // \\ UPLOAD FILE // \\ // \\
export const requestFileUpload = payload => {
    return{
        type: type.REQUEST_FILE_UPLOAD,
        file: payload
    }
}

export const resetFileUpload = payload => {
    return{
        type: type.RESET_FILE_UPLOAD
    }
}

// \\ // \\ ACTIVE SETTINGS FILE // \\ // \\
export const setActiveFileSettings = payload => {
    return{
        type: type.SET_ACTIVE_FILE_SETTINGS,
        settings: payload
    }
}

export const resetActiveFileSettings = () => {
    return{
        type: type.RESET_ACTIVE_FILE_SETTINGS
    }
}

// \\ // \\ ACTIVE SETTINGS ADD PASSWORD // \\ // \\
export const requestSettingsAddPassword = payload => {
    return{
        type: type.REQUEST_ADD_PASSWORD_FILE,
        info: payload
    }
}

export const resetSettingsAddPassword = () => {
    return{
        type: type.RESET_ADD_PASSWORD_FILE
    }
}

// \\ // \\ ACTIVE SETTINGS REMOVE PASSWORD // \\ // \\
export const requestSettingsRemovePassword = payload => {
    return{
        type: type.REQUEST_REMOVE_PASSWORD_FILE,
        info: payload
    }
}

export const resetSettingsRemovePassword = () => {
    return{
        type: type.RESET_REMOVE_PASSWORD_FILE
    }
}

export const appendDeletionArray = payload => {
    return{
        type: type.APPEND_FILES_DELETION_ARRAY,
        id: payload
    }
}

export const subtractDeletionArray = payload => {
    return{
        type: type.SUBTRACT_FILES_DELETION_ARRAY,
        id: payload
    }
}

export const requestDeleteFileArray = payload => {
    return{
        type: type.REQUEST_DELETE_FILE_ARRAY,
        details: payload
    }
}

export const resetDeleteFileArray = () => {
    return{
        type: type.RESET_DELETE_FILE_ARRAY
    }
}